import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isSmall: null,
}

const resolutionSlice = createSlice({
    name: 'resolution',
    initialState,
    reducers: {
        currentScreen: (state, action) => {
            state.isSmall = action.payload;
        }
    }
})

export const { currentScreen } = resolutionSlice.actions;
export default resolutionSlice.reducer;